export default __webpack_public_path__ + "static/media/location.b10a89d1.svg";